import { Route, Routes } from 'react-router-dom';
import { Dashboard } from './dashboard/Dashboard';
import { CompanyDirectors } from './CompanyDirectors';
import { Cases } from './Cases';

export const About = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="company-directors" element={<CompanyDirectors />} />
      <Route path="cases" element={<Cases />} />
    </Routes>
  );
};
